// Dedicated i18next instance for the migrated LMUTV storefront.
//
// Using a SEPARATE instance (createInstance) — instead of adding a namespace to
// the hub's i18n — lets every copied LMUTV component keep using its default
// `translation` namespace unchanged. This instance loads the LMUTV strings from
// `lmutv.json` (so it never clashes with the hub's `translation.json`), and is
// provided to the LMUTV subtree via <I18nextProvider> in LmuTvApp.
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

export const MyLanguages = [
  { label: "English", code: "gb" },
  { label: "Deutsch", code: "de" },
  { label: "Français", code: "fr" },
  { label: "Italiano", code: "it" },
];

const lmuI18n = i18next.createInstance();

export function GetInitialLanguage() {
  const browserLanguage = lmuI18n.language || window.navigator.language;
  const normalizedLanguage = browserLanguage.split("-")[0];
  const matchedLanguage = MyLanguages.find((lang) => lang.code === normalizedLanguage);
  return matchedLanguage || MyLanguages[0];
}

const version = new Date().getTime();
lmuI18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    whitelist: ["de", "gb", "fr", "it"],
    debug: false,
    fallbackLng: "gb",
    backend: {
      // The LMUTV strings live in lmutv.json (loaded as the default `translation` ns).
      loadPath: `/locales/{{lng}}/lmutv.json?v=${version}`,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default lmuI18n;
